import source from '../../../../docs/MAX/src/consts/languages.json'

import { SelectionOption } from '../core/types/chat.types'

const languages = source as SelectionOption[]

export default languages
